import { FC } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Alert from '@mui/material/Alert';
import { useTranslation } from 'react-i18next';

type LocationsMapDisclaimerProps = {
  testId: string;
};

export const LocationsMapDisclaimer: FC<LocationsMapDisclaimerProps> = (props) => {
  const { testId } = props;
  const { t } = useTranslation();

  return (
    <Alert
      data-testid={testId}
      severity="warning"
      icon={<InfoOutlinedIcon />}
      sx={{ alignItems: 'center' }}
    >
      {t('locations.map.disclaimer')}
    </Alert>
  );
};
